import React from "react";
import { MenuBoardTabMenu } from "../../styled/setting";

const TabMenu = ({ activeTab, setActiveTab }) => {
  const tabs = ["방문/픽업주문", "정보"];
  return (
    <MenuBoardTabMenu className="center">
      {tabs.map((tab, idx) => (
        <li
          key={tab}
          className={idx === activeTab ? "active" : ""}
          onClick={() => setActiveTab && setActiveTab(idx)}>
          {tab}
        </li>
      ))}
    </MenuBoardTabMenu>
  );
};

export default TabMenu;
